import React, { useEffect, useRef, useState } from 'react';

import { useSessionContext } from '../contexts/SessionContext';
import { useCanvasSketchContext } from '../contexts/CanvasSketchContext';
import { useInspectorStyles } from '../pages/VirtualSession/styles';

export const CanvasImage = () => {
  const styles = useInspectorStyles();
  const canvasImageRef = useRef<HTMLCanvasElement>(null);
  const {
    setCanvasSketchSize,
    setIsImageLoading,
    selectedImage,
    selectedImageElement,
    strokesLayer,
  } = useSessionContext();

  const { setStrokeList } = useCanvasSketchContext();

  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    console.log('::::inside useEffect...');
    const canvasImage = canvasImageRef?.current;
    const ctx = canvasImage?.getContext('2d');
    const img = selectedImageElement;

    if (!ctx || !canvasImage?.parentElement) return;

    if (!img) {
      ctx.clearRect(0, 0, canvasImage.width, canvasImage.height);
      canvasImage.width = 0;
      canvasImage.height = 0;
      return;
    }

    const bounds = canvasImage.parentElement.getBoundingClientRect();
    if (!bounds) return;

    console.log(
      `::::CanvasImage image is loaded img.width: ${img.width} x  img.height: ${img.height}`,
      bounds,
    );

    const sx = bounds.width / img.width;
    const sy = bounds.height / img.height;
    const s = sx < sy ? sx : sy;

    const width = Math.round(s * img.width);
    const height = Math.round(s * img.height);

    console.log(
      `canvasImage.width: ${canvasImage.width} width: ${width} canvasImage.height: ${canvasImage.height} height: ${height}`,
    );

    if (canvasImage.width !== width || canvasImage.height !== height) {
      console.log(`set canvasImage size to ${width} X ${height}`);

      setWidth(width);
      setHeight(height);

      setCanvasSketchSize({ width: width, height: height });
      canvasImage.width = width;
      canvasImage.height = height;
    }

    console.log('draw selectedImage to CanvasImage..');
    console.log('selectedImage:', selectedImage);
    ctx.drawImage(img, 0, 0, width, height);

    setTimeout(() => {
      ctx.drawImage(img, 0, 0, width, height);
      setIsImageLoading(false);
    }, 100);

    let strokes: any[] = [];
    if (selectedImage?.strokes)
      try {
        strokes = selectedImage.strokes[strokesLayer];
        if (!Array.isArray(strokes)) strokes = [strokes];
      } catch (e) {}

    setStrokeList([...strokes]);
  }, [strokesLayer, selectedImageElement, canvasImageRef]);

  return (
    <canvas
      ref={canvasImageRef}
      width={width}
      height={height}
      style={{
        ...(styles.screenshot as React.CSSProperties),
        backgroundColor: 'rgba(255, 255, 0, .2)',
      }}
    />
  );
};
